import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboard.vue'
import Error from './views/Error.vue'
import Callback from './components/Callback.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/error',
      name: 'error',
      component: Error,
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
  ],
})
